export const CHANGE_VALUES = 'CHANGE_VALUES'
export const GET_VALUES = 'GET_VALUES'
export const GET_VALUES_FOR_TABLE = 'GET_VALUES_FOR_TABLE'
